<ngx-spinner bdColor="rgba(51,51,51,0.55)"
    size="medium"
    color="#fff"
    type="line-spin-clockwise-fade"
    [fullScreen]="false">
    <p class="loading">{{ 'general.loading' | translate }}...</p>
</ngx-spinner>
<div class="modal-header navbar-alertia">
    <h4 class="modal-title">{{'alert_activity.add_note' | translate}}</h4>
    <button type="button" class="close" (click)="activeModal.close()">&times;</button>
</div>
<div class="modal-body">
    <form class="w-100" [formGroup]="addActivityForm" [ngClass]="" (ngSubmit)="addActivity()" name="form">
        <div class="row">
            <div class="col-12">
                <label for="Note">{{'alert_activity.note' | translate}} <span class="error">*</span></label>
                <textarea class="form-control" id="Note" formControlName="Note" maxlength="250" rows="3" [ngClass]="{ 'is-valid': Note['valid'], 'is-invalid': Note['invalid'] }" required = "required"  ></textarea>
                <ng-container *ngIf="addActivityForm.get('Note').invalid && (formSubmitted || addActivityForm.get('Note').touched || addActivityForm.get('Note').dirty)">
                    <div *ngIf="addActivityForm.get('Note').hasError('required')"  class="error align-left">
                        {{'general.required_field' | translate}}
                    </div>
                    <div *ngIf="addActivityForm.get('Note').hasError('pattern')"  class="error align-left">
                        {{'error.address' | translate}}
                    </div>
                </ng-container>
            </div>
        </div>
        <hr class="hr-m">
        <div class="row">
            <div class="col-12 text-right">
                <button type="submit" title="{{'general.add' | translate}}" class="btn btn-green btn-h-green">
                    {{'general.add' | translate}}
                </button>
            </div>
        </div>
    </form>
</div>
